import { render, staticRenderFns } from "./ErrosHikcentral.vue?vue&type=template&id=29318985&"
import script from "./ErrosHikcentral.vue?vue&type=script&lang=js&"
export * from "./ErrosHikcentral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports